import React from 'react';
import ReactDOM from 'react-dom/client';

import FontManager from 'components/FontManager';
import './index.css';
import App from './App';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WhatsappLink from 'components/WhatsappLink';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <>
    <WhatsappLink />
    <FontManager />
    <ToastContainer
      toastClassName={() =>
        'relative flex py-4 px-3 rounded overflow-hidden cursor-pointer bg-white shadow-lg'
      }
      bodyClassName={() => 'text-black text-base font-normal'}
      position="bottom-left"
      autoClose={4000}
      hideProgressBar={true}
      newestOnTop={false}
      closeButton={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
    <App />
  </>,
);
